// extracted by mini-css-extract-plugin
export var formContainer = "_bx-0";
export var message = "_bx-1";